module.exports = __webpack_public_path__ + "media/src/images/kddi-logo-faaf2b977daedd9183d8cd8eaec6e9e0.png";